import React from "react";
import { Mail } from "lucide-react";
import { PageShell, usePageTitle } from "./components/site/Layout";
import { buttons } from "./components/site/ui";
import { CONTACT_EMAIL } from "./config";

const ErrorPage = () => {
  usePageTitle("Report a problem");
  const subject = encodeURIComponent("Car Sense problem report");

  return (
    <PageShell>
      <div className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 sm:py-16">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">Report a problem</h1>
        <p className="mt-4 text-lg leading-8 text-slate-600">
          Something not working, or a report that doesn't look right? Email us and we'll look into it.
        </p>

        <div className="mt-8 rounded-lg border border-slate-200 bg-slate-50 p-6">
          <h2 className="font-semibold text-slate-900">It helps to include</h2>
          <ul className="mt-3 list-disc space-y-1.5 pl-5 text-sm leading-6 text-slate-600">
            <li>The registration, or the make and model, you searched for</li>
            <li>What you expected to see, and what happened instead</li>
            <li>The device and browser you were using</li>
          </ul>
          <a href={`mailto:${CONTACT_EMAIL}?subject=${subject}`} className={`${buttons.primary} mt-6`}>
            <Mail className="h-4 w-4" aria-hidden="true" />
            Email {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </PageShell>
  );
};

export default ErrorPage;
